import { addWeeks, format, subWeeks } from 'date-fns';

interface selectDateParams {
	biweekly: boolean;
	startedAt?: Date | null;
}
interface SelectDateResult {
	startDate: string;
	endDate: string;
}

export const selectDate = ({ biweekly, startedAt }: selectDateParams): SelectDateResult => {
	const weekOffset = biweekly ? 2 : 1;
	const DATE_FORMAT = 'yyyy-MM-dd';
	const startDate = subWeeks(startedAt || new Date(), weekOffset);
	const endDate = addWeeks(startedAt || new Date(), weekOffset);
	return {
		startDate: format(startDate, DATE_FORMAT),
		endDate: format(endDate, DATE_FORMAT),
	};
};
